module.exports = __webpack_public_path__ + "static/media/starEmpty.7947c595.svg";